import React from "react";
import Cookie from "js-cookie";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import { Row, Table, Card, Spin, Empty, Tabs, Pagination } from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class IntegralProportion extends React.Component {
    state = {
        loading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
        },
        data: [], // 比例记录
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/coin/effect_rate_list", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    render () {
        return (
            <Card
                title={
                    <h2>
                        {this.props.language["proportionRecord"]}
                    </h2>
                }
                type="inner"
                className='m10'
            >
                {this.state.data.length > 0 &&
                    <>
                        <Tabs tabPosition={isMobileDevice() ? 'top' : 'left'} style={{ height: isMobileDevice() ? 'auto' : 890 }}>
                            {this.state.data.map((item, index) =>
                                <Tabs.TabPane tab={`${item.begin_date} ~ ${item.end_date}`} key={index}>
                                    <Table
                                        dataSource={item.coin_rate_list}
                                        pagination={false}
                                        loading={this.state.loading}
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["proxyPlatformTokenType"]}
                                            dataIndex="currency_name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["proportion"]}
                                            dataIndex="currency_rate"
                                        />
                                        {Cookie.get("isAce1") !== 'true' &&
                                            <Table.Column
                                                align="center"
                                                title={this.props.language["usdt"]}
                                                dataIndex="usdt_rate"
                                            />
                                        }
                                    </Table>
                                </Tabs.TabPane>
                            )}
                        </Tabs>
                        <Row type="flex" justify="end">
                            <Pagination
                                className="pagination mt10"
                                showQuickJumper
                                showSizeChanger
                                size={isMobileDevice() ? 'small' : ''}
                                showTotal={(total) =>
                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                                }
                                pageSizeOptions={["10", "20", "30", "40"]}
                                current={this.state.queryParams.page}
                                pageSize={this.state.queryParams.limit}
                                total={this.state.queryParams.total}
                                onChange={(current, pageSize) =>
                                    this.hanldeChangePage({ current, pageSize })
                                }
                                onShowSizeChange={(current, pageSize) =>
                                    this.hanldeChangePage({ current, pageSize })
                                }
                            />
                        </Row>
                    </>
                }

                {/* 暂无数据 */}
                {!this.state.data.length && (
                    <>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </>
                )}
            </Card>
        );
    }
}
